import { Navigate, useLocation } from 'react-router-dom';
import { useGetMe } from '@/hooks/shared/useGetMe';
import { APP_LINKS } from '@/helpers/links';

const LENDER_CABINET_PATHS = [
  APP_LINKS.dashboard,
  APP_LINKS.fundraising,
  APP_LINKS.payments,
  APP_LINKS.activity,
  APP_LINKS.profile,
  APP_LINKS.loans,
  APP_LINKS.founders,
  APP_LINKS.loanTerms
];

export const CabinetGuard = ({ children }) => {
  const { isLender, isCombinedMode, isLoading } = useGetMe();
  const location = useLocation();

  if (isLoading) return null;

  const isSplitLender = !isCombinedMode && isLender;

  if (isSplitLender) {
    const isAllowed = LENDER_CABINET_PATHS.some(path =>
      location.pathname.startsWith(path),
    );
    if (!isAllowed) {
      return <Navigate to={APP_LINKS.dashboard} replace />;
    }
  }

  return children;
};
